import { Box, Typography } from "@material-ui/core";
import { useEffect, useMemo, useState } from "react";
import LineChart from "src/components/ScoringChart/Line/LineChart";
import { beautifulTooltip } from "src/components/ScoringChart/tool-utils/BeautifulTooltip";
import CssSelector from "src/components/Selector/CssSelector";
import { portfolioChartConfig } from "src/config/constants";
import { useTokenAnalysisContext } from "src/context/tokenAnalysisContext";
import { numberWithCommas, toFixed } from "src/services/utils";

const chartOption = [
  { label: "Price", value: 0 },
  { label: "Trading Volume", value: 1 },
  { label: "Market Cap", value: 2 },
  { label: "Number Of Transactions", value: 3 },
  { label: "Number Of Holders", value: 4 },
];

const getOption = (type) => {
  return {
    chart: {
      height: 340,
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: [
      {
        gridLineWidth: 0,
        label: {
          enabled: true,
        },
        title: {
          text: chartOption[type]["text"],
        },
      },
    ],
    ...beautifulTooltip((value) => numberWithCommas(toFixed(value, 3))),
    legend: {
      enabled: true,
    },
  };
};

export default function TokenComparisonHistoryChart({ tokenIds }) {
  const [type, setType] = useState(0);
  const { getTokenHistory } = useTokenAnalysisContext();
  const [fullData, setFullData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(async () => {
    setLoading(true);
    if (tokenIds) {
      let promiseList = [];
      for (var tokenId of tokenIds) {
        promiseList.push(getTokenHistory(tokenId));
      }
      const promiseResult = await Promise.all(promiseList);
      setFullData(promiseResult);
    }
    setLoading(false);
  }, [tokenIds]);

  const { series } = useMemo(() => {
    let result = [];
    if (fullData && !loading) {
      const config = portfolioChartConfig[type];
      let index = 0;
      for (var tokenId of tokenIds) {
        if (fullData[index])
          result.push({
            name: tokenId,
            data: [].concat(fullData[index][config["types"]]),
          });
        index++;
      }
    }
    return {
      series: result,
    };
  }, [fullData, type, loading]);

  return (
    <>
      <Box pb={2}>
        <Typography variant="h4">Token History</Typography>
      </Box>
      <CssSelector
        style={{ width: "100%" }}
        defaultSelectedItem={{ label: "Price" }}
        config={chartOption}
        event={{ onChooseItem: (_, item) => setType(item.value) }}
      />
      <LineChart isLoading={loading} series={series} option={getOption(type)} />
    </>
  );
}
